import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { appRouter } from "./pages/App";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Root element not found");
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={appRouter} />
  </StrictMode>
);
